var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4582 43.7503C35.3888 43.7503 44.2498 34.8893 44.2498 23.9587C44.2498 13.028 35.3888 4.16699 24.4582 4.16699C13.5275 4.16699 4.6665 13.028 4.6665 23.9587C4.6665 34.8893 13.5275 43.7503 24.4582 43.7503Z",
    fill: "#CFCFD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 46L40.5 40",
    stroke: "#CFCFD2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2535 22.6834C21.1406 22.6721 21.0052 22.6721 20.8811 22.6834C18.1953 22.5931 16.0625 20.3926 16.0625 17.6842C16.0625 14.9195 18.2969 12.6738 21.0729 12.6738C23.8377 12.6738 26.0833 14.9195 26.0833 17.6842C26.072 20.3926 23.9392 22.5931 21.2535 22.6834Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4348 14.9307C31.624 14.9307 33.3844 16.7024 33.3844 18.8803C33.3844 21.0131 31.6917 22.751 29.5815 22.83C29.4912 22.8187 29.3896 22.8187 29.2881 22.83",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6112 26.8477C12.8803 28.6758 12.8803 31.6549 15.6112 33.4718C18.7145 35.5482 23.8039 35.5482 26.9072 33.4718C29.6381 31.6437 29.6381 28.6645 26.9072 26.8477C23.8152 24.7826 18.7257 24.7826 15.6112 26.8477Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6128 32.9867C32.4253 32.8174 33.1927 32.4901 33.8246 32.0049C35.585 30.6846 35.585 28.5066 33.8246 27.1863C33.2039 26.7123 32.4479 26.3964 31.6466 26.2158",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPeople);
export default __webpack_public_path__ + "static/media/search_people.f97b1dbc2a1931fd06d9f4588d897e06.svg";
export { ForwardRef as ReactComponent };